<template>
  <div class="pricing-plans row no-gutters">
    <div class="pricing-plan col-sm-12">
      <div class="plan-head user-profile compact">
        <div class="up-head-w" :style="formatImageAvatar(product)">
          <div class="up-main-info">
            <h2 class="up-header">{{productDisplayName(product)}}
              <span />
            </h2>
            <h6 class="up-sub-header">
              <div class="value badge badge-pill bold ">{{product.item_parent_identifier}}</div>
            </h6>
            <h6 class="up-sub-header">
              <div class="value badge badge-pill bold text-capitalize">{{product.category_name}}</div>
            </h6>

          </div>
        </div>
      </div>
      <div class="plan-body">

        <!-- <div class="element-wrapper col-12 p-t-10">
                    <div class="element-box-tp">
                        <div class="todo-list">
                            <a class="todo-item complete" href="#">
                                <div class="ti-info">
                                    <div class="ti-header">Images</div>
                                    <div class="ti-sub-header">Images sent to final location</div>
                                </div>
                                <div class="ti-icon">
                                    <i class="os-icon os-icon-check"></i>
                                </div>
                            </a>
                            <a class="todo-item complete" href="#">
                                <div class="ti-info">
                                    <div class="ti-header">Copy</div>
                                    <div class="ti-sub-header">Copy sent to final location</div>
                                </div>
                                <div class="ti-icon">
                                    <i class="os-icon os-icon-check"></i>
                                </div>
                            </a>

                        </div>
                    </div>
                </div> -->

        <div class="chat-info-section p-t-10">

          <div class="ci-content">
            <div class="user-name" v-for="info in quickInfo(product)">
              <h6 class="user-title">{{info.value}}</h6>
              <div class="user-role">{{capitalize(info.name)}}</div>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import CommonFunctions from '@/mixins/common-functions.js'
import Product from '@/mixins/product'

export default {
  props: ['product'],
  mixins: [CommonFunctions, Product],
  data () {
    return {
      statusFilters: [
        { name: 'All', key: '' },
        { name: 'Open', key: '1' },
        { name: 'Closed', key: '0' },
        { name: 'Cancelled', key: '3' }
      ]
    }
  },
  methods: {
    formatImageAvatar: function (product) {
      return (
        'background-image: url(' +
        product.preview +
        '); background-size:100%; background-repeat: no-repeat;'
      )
    }
  }
}
</script>

<style>
.open {
  color: #75da62 !important;
}
.closed {
  color: #23b7e5 !important;
}
.cancelled {
  color: #ddd;
}
.users-list-w {
  padding: 10px;
}
.pricing-plans {
  background-color: #fff;
  border-right: 1px solid #ddd;
  height: calc(100vh - 54px);
}
.pricing-plan .plan-description h6 {
  text-transform: uppercase;
  letter-spacing: 2px;
  margin-top: 10px;
  font-size: 0.9rem;
}
.plan-description {
  background-color: #fff;
  padding: 10px;
}
.plan-image > div {
  font-size: 50px;
  color: #047bf8;
}
.plan-name {
  font-weight: 600;
}
.pricing-plan .plan-head {
  background-color: #fff;
  padding-top: 10px;
}
.pricing-plan,
.pricing-plan .plan-body {
  background-color: #fff;
}

.pricing-plan .plan-name {
  padding-bottom: 10px;
}
.pricing-plan .plan-price-w {
  padding-top: 10px;
  margin-bottom: 10px;
}
.pricing-plan .plan-btn-w {
  padding-bottom: 10px;
  display: inline-block;
  padding-right: 10px;
  padding-left: 10px;
}
.support-ticket-info {
  background-color: #f6f7f9;
  background: -webkit-gradient(
    linear,
    left top,
    left bottom,
    from(#eff1f7),
    to(#f9fafc)
  );
  background: linear-gradient(to bottom, #eff1f7, #f9fafc);
  padding: 10px 20px;
  border-radius: 6px;
  -webkit-box-flex: 0;
  -ms-flex: 0 0 250px;
  flex: 0 0 250px;
  position: relative;
}
.support-ticket-info .close-ticket-info {
  position: absolute;
  top: 10px;
  right: 15px;
  color: #047bf8;
  text-decoration: none;
  font-size: 20px;
}
.support-ticket-info .customer {
  text-align: center;
  /* padding-bottom: 20px; */
  margin-bottom: 30px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
}
.support-ticket-info .customer .avatar {
  margin-bottom: 10px;
}
.support-ticket-info .customer .customer-name {
  margin-bottom: 5px;
}
.support-ticket-info .info-section {
  padding: 0px;
  margin-bottom: 40px;
  padding-bottom: 20px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
}

.support-ticket-info .customer .avatar img {
  border-radius: 50px;
  width: 100px;
  height: auto;
}

.support-ticket-info .customer .customer-name {
  margin-bottom: 5px;
}

.support-ticket-info .customer .customer-tickets {
  color: #636c72;
}

.support-ticket-info .info-header {
  color: #047bf8;
  text-align: center;
  margin-bottom: 15px;
}

.support-ticket-info .info-section .label {
  color: #636c72;
  display: block;
  margin-bottom: 5px;
}
.support-ticket-info .info-section .value {
  display: block;
}

.support-ticket-info .info-section:last-child {
  margin-bottom: 0px;
  border-bottom: none;
  padding-bottom: 0px;
}

.support-ticket-info ul.users-list {
  list-style: none;
  padding: 0px;
  margin: 0px;
  margin-bottom: 20px;
}

.support-ticket-info ul.users-list li {
  margin-bottom: 10px;
}

.support-ticket-info ul.users-list.as-tiles {
  display: inline-block;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
}

.support-ticket-info ul.users-list.as-tiles li {
  text-align: center;
  -webkit-box-flex: 0;
  -ms-flex: 0 0 47%;
  flex: 0 0 47%;
}

.support-ticket-info ul.users-list.as-tiles li a {
  display: block;
  background-color: #fff;
  -webkit-box-shadow: 0px 2px 4px rgba(126, 142, 177, 0.12);
  box-shadow: 0px 2px 4px rgba(126, 142, 177, 0.12);
  padding: 10px;
  border-radius: 6px;
  margin: 0px;
  text-decoration: none;
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
}

.support-ticket-info ul.users-list.as-tiles li a span {
  display: block;
  border-bottom: none;
  color: #3e4b5b;
  font-size: 0.72rem;
}

.support-ticket-info ul.users-list.as-tiles li a .avatar {
  margin: 0px;
  width: 50px;
  height: 50px;
  margin-bottom: 5px;
  background-size: cover;
  display: inline-block;
  border-radius: 50px;
}

.support-ticket-info ul.users-list.as-tiles li a i {
  margin-right: 0px;
  margin-bottom: 10px;
}

.support-ticket-info ul.users-list.as-tiles li a:hover {
  -webkit-box-shadow: 0px 5px 12px rgba(126, 142, 177, 0.2);
  box-shadow: 0px 5px 12px rgba(126, 142, 177, 0.2);
  -webkit-transform: translateY(-3px);
  transform: translateY(-3px);
}

.support-ticket-info ul.users-list.as-tiles li a:hover span {
  color: #047bf8;
}
</style>
